import { useController } from "react-hook-form";
import { FormControlLabel, Checkbox } from "@mui/material";
export const ControlledCheckbox = ({
  control,
  required = true,
  name,
  label,
  ...props
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
    rules: { required },
  });

  return (
    <FormControlLabel
      label={label}
      control={
        <Checkbox value={field.value} onChange={field.onChange} {...props} />
      }
    />
  );
};
